import React from 'react'
import { useRouter } from 'next/router'
import { Box, Container, Grid } from '@mui/material/'
import { StyledDiv } from '@components/atoms/StyledDiv'
import CatalogList from '@components/organisms/CatalogList'
import { Pagination } from '@components/organisms/Pagination'
import { CATALOG_PAGINATION_LENGTH } from '@services/coataz/constants'
import { useGetCompanyInfoQuery } from '@services/cloud/client'
import CompanyTabs from '../CompanyTabs'
import CompanyMainInfoView from '../CompanyMainInfoView'

export function CompanyCatalogs() {
  const router = useRouter()
  const { id, page } = router.query
  const pageNumber = Number(page) ? Number(page) : 1

  const { data, error, loading } = useGetCompanyInfoQuery({
    variables: {
      args: {
        companyId: id as string,
        catalogListLength: CATALOG_PAGINATION_LENGTH,
        catalogListSkip: pageNumber,
      },
    },
  })

  const handlePageClick = (paginationData: { selected: number }) => {
    window.scrollTo(0, 0)
    router.push(`/company/${id}/catalog?page=${paginationData.selected + 1}`)
  }

  const pageCount =
    typeof data?.company?.catalogLength === 'number'
      ? Math.ceil(data.company.catalogLength / CATALOG_PAGINATION_LENGTH)
      : 0

  if (error) {
    return <div>404 ページが存在しません</div>
  }

  if (loading) {
    return null
  }

  if (!data || !data.company) {
    return <div>404 ページが存在しません</div>
  }

  return (
    <Box minHeight="78vh" mb={1}>
      <StyledDiv>
        <CompanyMainInfoView company={data.company} />
        <CompanyTabs />
        <Container maxWidth="md">
          <Box>
            {Array.isArray(data.company.catalogs) && data.company.catalogs.length > 0 && (
              <Box mt={3}>
                <Grid container={true} spacing={1}>
                  {data.company.catalogs.map((catalog: any) => (
                    <Grid key={catalog.id} item={true} xs={6} sm={4} md={3}>
                      <CatalogList catalog={catalog} />
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )}
          </Box>
          {pageCount > 0 && (
            <Box pt={3} pb={3}>
              <Pagination
                pageCount={pageCount}
                pageNumber={pageNumber}
                handlePageClick={handlePageClick}
              />
            </Box>
          )}
        </Container>
      </StyledDiv>
    </Box>
  )
}
